import * as Yup from 'yup';

export const templateSchema = Yup.object().shape({
  // Basic Info
  templateName: Yup.string()
    .required('Template Name is required')
    .min(3, 'Template Name must be at least 3 characters'),

  // Company Info (Required)
  companyName: Yup.string()
    .required('Company Name is required')
    .min(2, 'Company Name must be at least 2 characters'),

  companyEmail: Yup.string()
    .required('Company Email is required')
    .email('Invalid email format'),

  companyPhone: Yup.string()
    .required('Phone number is required')
    .min(10, 'Phone number must be at least 10 digits'),

  companyAddress: Yup.string()
    .required('Company Address is required'),

  cin: Yup.string()
    .required('CIN is required'),

  gst: Yup.string()
    .nullable() // Allows the value to be null
    .notRequired() // Marks it as optional
    .transform((value, originalValue) => (originalValue === '' ? null : value)) // Treats empty input as null (valid)
    .min(15, 'GST Number field should accept 15 digit alphanumeric unique code.') // Only runs if value exists
    .max(15, 'GST Number field should accept 15 digit alphanumeric unique code.')
    

  
    
});

// Helper to extract errors
export const extractErrors = (err: any) => {
  const newErrors: Record<string, string> = {};

  // Check if it's a Validation Error with multiple inner errors
  if (err?.inner && Array.isArray(err.inner)) {
    err.inner.forEach((error: any) => {
      if (error.path) {
        newErrors[error.path] = error.message;
      }
    });
  } 
  // Fallback: If it's a single error without inner array
  else if (err?.path && err?.message) {
    newErrors[err.path] = err.message;
  }
  // Fallback: Generic error (optional)
  else {
    console.error("Non-validation error caught:", err);
  }

  return newErrors;
};